export const CHROME_WEB_STORE_EXTENSION_ID = "bbgcekhigafammpphfipefklildgjmfh";

export const CHROME_EXTENSION_ID: string =
  import.meta.env.VITE_CHROME_EXTENSION_ID || CHROME_WEB_STORE_EXTENSION_ID;

export const CHROME_WEB_STORE_URL = `https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}`;

const PING_TYPE = "ROSC_EXTENSION_PING";

type ChromeRuntime = {
  sendMessage: (
    extensionId: string,
    message: unknown,
    responseCallback?: (response: unknown) => void
  ) => void;
  lastError?: { message?: string };
};

type PingResponse = {
  ok?: boolean;
  version?: string;
};

export type ChromeExtensionDetection = {
  installed: boolean;
  version?: string;
};

function getChromeRuntime(): ChromeRuntime | undefined {
  const chromeApi = (
    globalThis as typeof globalThis & { chrome?: { runtime?: ChromeRuntime } }
  ).chrome;
  return chromeApi?.runtime;
}

export function detectChromeExtension(
  timeoutMs = 800
): Promise<ChromeExtensionDetection> {
  const runtime = getChromeRuntime();
  if (!runtime?.sendMessage || !CHROME_EXTENSION_ID) {
    return Promise.resolve({ installed: false });
  }

  return new Promise((resolve) => {
    let settled = false;
    const timerRef: { id?: ReturnType<typeof setTimeout> } = {};

    const finish = (result: ChromeExtensionDetection): void => {
      if (settled) return;
      settled = true;
      if (timerRef.id !== undefined) {
        clearTimeout(timerRef.id);
      }
      resolve(result);
    };

    timerRef.id = setTimeout(() => {
      finish({ installed: false });
    }, timeoutMs);

    try {
      runtime.sendMessage(
        CHROME_EXTENSION_ID,
        { type: PING_TYPE },
        (response: unknown) => {
          if (runtime.lastError) {
            finish({ installed: false });
            return;
          }
          const payload = response as PingResponse | undefined;
          if (!payload?.ok) {
            finish({ installed: false });
            return;
          }
          finish({ installed: true, version: payload.version });
        }
      );
    } catch {
      finish({ installed: false });
    }
  });
}
